import React ,{useState ,useEffect}  from "react";
import { Box } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
} from "@chakra-ui/react";
import Grid from '@material-ui/core/Grid';
import * as Actions from "../../store/action/party";
import Skeleton from '@mui/material/Skeleton';
import {getLabelClass, renderInputOrSpan} from "../../utils/formUtils";
import {toggleExpansion} from "../../utils/toggleExpansion";
import {translatePartyRole} from "../../utils/traductionPartyRole";
import * as claimActions from "../../store/action/claim.js";  
import { useDispatch } from "react-redux";
const useStyles = makeStyles((theme) => ({
  labelInput: {
    fontFamily: "Poppins",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "18px",
    textAlign: "left",
    color: "rgba(70, 78, 95, 1)",
    marginBottom : '10px',
  },
  styleInput: {
    borderRadius: "4px",
    border : 0,
    background: "rgba(243, 246, 249, 1)",
    height: "36px",
    width: "250px",
    padding: "10px",
    fontFamily: "Poppins",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "18px",
    textAlign: "left",
    color: "rgba(70, 78, 95, 1)",
  },
  paper: {
    width: "100%",
    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.06)",
  },
  customAccordionItem : {
    width: "100%",
    marginBottom: "20px",
    border: "1px solid rgba(187, 200, 8, 1)",
    borderRadius: "11px",
    // "&:focus-within": {
    //   border: "none",
    // },
  },
  expanded: {
    border: "none",
  },

  styleSpan:{
    color: 'rgba(70, 78, 95, 1)',
    fontSize: '12px',
    fontWeight: 400,
    fontFamily: 'Poppins'
  },
  styleSpanLabel:{
    color: 'rgba(70, 78, 95, 1)',
    fontSize: '12px',
    fontWeight: 600,
    fontFamily: 'Poppins'
  }
}));

function TiersSection(props) {
  const classes = useStyles();
  const [party, setParty] = useState([]);
  const listOfParties = props.listOfParties ;
  const [loading, setLoading] = useState(true);
  const renderAsSpans = props.renderAsSpans 
  const [expandedItems, setExpandedItems] = useState(new Set([0]));
  const dispatch = useDispatch();


  const getPhone = (partyCommunicationChannels) => {
    let Channel = partyCommunicationChannels?.find(party => party.communicationChannel?.type === "PHONECONTACT" &&  party.status === "ACTIVE");
      if(!Channel){
        Channel = partyCommunicationChannels?.find(party => party.communicationChannel?.type === "HOMEPHONECONTACT" &&  party.status === "ACTIVE");
      }

    const phoneValue = Channel ? Channel.communicationChannel.value : "N/A"
    return phoneValue
  }

  const getEmail = (partyCommunicationChannels) => {
    const Channel = partyCommunicationChannels?.find(party => party.communicationChannel?.type === "EMAILCONTACT" &&  party.status === "ACTIVE");
    const emailValue = Channel ? Channel.communicationChannel.value : "N/A"
    return emailValue
  }

  const getAdresse = (partyAddresses) => {
    const address = partyAddresses?.[0]?.address
    if(!address){
      return "N/A"
    }
    // n'affiche que les morceaux renseignes : les adresses du batch MAE n'ont
    // ni numero ni gouvernorat (state), l'ancien code rendait alors "N/A"
    const parts = [address.number, address.street, address.city, address.state?.label, address.postalCode?.postalCode]
    const value = parts.filter(part => part !== undefined && part !== null && part !== "" && part !== 0).join(" ")
    return value || "N/A"
  }


  const getParties = async (partyIds) => {
    try {
      const partyDetails = await Promise.all(partyIds?.map(partyId => Actions.getPartyDetails(partyId)));
      return partyDetails;
    } catch (error) {
      console.error(`Error fetching parties: ${error}`);
      return [];
    }
  };
  const fetchParties = async () => {
    setLoading(true);
 
    const partyData = await getParties(listOfParties?.map(party => party.partyUid));
    const filteredarty = partyData.filter(item => item !== undefined);
    // Add role to party where same uid
    filteredarty.forEach((party) => {
      const matchingParty = listOfParties.find((p) => p.partyUid === party.uid);
      if (matchingParty) {
        party.roleParty = matchingParty.role;
      }
    });
    setParty(Array.isArray(filteredarty) ? filteredarty : [filteredarty]);
    setLoading(false);
  };
  useEffect(() => {
    fetchParties();
  }, []);

  useEffect(() => {
    const insured = party.filter((tiers) => tiers?.roleParty === "InsuredDriver");

    if (insured.length > 0) {
        const idAssure = insured[0]?.additionalData?.idAssure;
        if (idAssure) {
            dispatch(claimActions.fetchPiClaimData(idAssure)); 
        }
    }
}, [dispatch, party]);


  const insured = party?.filter((tiers) => tiers?.roleParty === "InsuredDriver");

  // Check if there are any results and access the `additionalData`
  if (insured && insured.length > 0) {
      console.log("idAssure:", insured[0]?.additionalData?.idAssure);
  } else {
      console.log("No insured driver found.");
  }
  
  return (
    <div style={{ padding: "40px" }}>
      <Accordion defaultIndex={[0]} allowMultiple  >
      {loading ?
      <>
      {[...Array(3)].map((row, index) => {
        return (
            <AccordionItem className={`${classes.customAccordionItem} ${renderAsSpans ? classes.expanded : ''}`} key={index}>
              <AccordionButton
                  onClick={() => toggleExpansion(index, expandedItems, setExpandedItems)}
                  style={{ height: "47px", border: "none", background: "rgba(249, 249, 249, 1)", padding: "10px", borderRadius: "11px" }}>
            <AccordionIcon  style={{ backgroundColor: "rgba(240, 243, 199, 1)", width: "25px", height: "25px", borderRadius: "5px", color: "rgba(187, 200, 8, 1)" , marginRight :'2%' }} />
              <Skeleton  size="30px" animation="wave" width={160} height={30}/>
          </AccordionButton>
          <AccordionPanel style={{ width: "100%", background: 'rgba(255, 255, 255, 1)', padding: '40px' , borderRadius: "11px" }}>
          <Grid container  style={{justifyContent: 'start' , marginBottom :'10px'}}  spacing={6} >
                  <Grid item >
                    <div className={classes.labelInput} style={{marginRight: "40px"}}>Code</div>
                    <Skeleton animation="wave" width={241} height={50}/>

                  </Grid>
                  <Grid item  >
                    <div className={classes.labelInput} style={{marginRight: "40px"}}>Nom et prénom</div>
                    <Skeleton animation="wave" width={241} height={50}/>
                  </Grid>
                  <Grid item  >
                    <div className={classes.labelInput} style={{marginRight: "40px"}}>Adresse</div>
                    <Skeleton animation="wave" width={241} height={50}/>
                  </Grid>
                  <Grid item  >
                    <div className={classes.labelInput} style={{marginRight: "40px"}}>Tél</div>
                    <Skeleton animation="wave" width={241} height={50}/>
                  </Grid>
                  <Grid item  >
                    <div className={classes.labelInput} style={{marginRight: "40px"}}>Email</div>
                    <Skeleton animation="wave" width={241} height={50} />
                  </Grid>
          </Grid>

          </AccordionPanel>
    </AccordionItem>

        )})}
      </>
      :
     <>
     {
      party.map((tiers, index) => (
        tiers?.type  ==='person' ?(
            <AccordionItem className={`${classes.customAccordionItem} ${renderAsSpans ? classes.expanded : ''}`} key={index}>
              <AccordionButton onClick={() => toggleExpansion(index, expandedItems, setExpandedItems)}
                               style={{ height: "47px", border: "none", background: "rgba(249, 249, 249, 1)", padding: "10px", borderRadius: "11px" }}>
                <AccordionIcon size="30px" style={{ backgroundColor: "rgba(240, 243, 199, 1)", width: "25px", height: "25px", borderRadius: "5px", color: "rgba(187, 200, 8, 1)" }} />
                <Box as="span"   textAlign='left' marginLeft='20px' style={{ color: "rgba(0, 34, 38, 1)", fontSize: '15px', fontWeight: 500, lineHeight: '21px', fontFamily: 'Poppins', }}>
                    {tiers?.name} {" "} {tiers?.lastName}
                </Box>
                <div style={{
                                  marginLeft: '10px',   height: '26px', borderRadius: '51px', background: 'rgba(240, 243, 199, 1)', textAlign: 'center', padding: '5px 20px',
                                  fontFamily: 'Poppins', fontSize: '10.69px', fontWeight: 400, lineHeight: ' 16.03px', color: 'rgba(187, 200, 8, 1)',
                              }}>
                                  {translatePartyRole(tiers?.roleParty) || "N/A"}
                              </div>
              </AccordionButton>
              <AccordionPanel style={{ width: "100%", background: 'rgba(255, 255, 255, 1)', padding: '30px' , borderRadius: "11px" }}>
              <Grid container  style={{justifyContent: 'start' , marginBottom :'10px'}}  spacing={2} >
                      <Grid item >
                        <div className={getLabelClass(renderAsSpans, classes)} style={{marginRight: "40px"}}>Code</div>
                        {/*<input disabled className={classes.styleInput} type='text' name="code" value={tiers?.code || "N/A"} /> */}
                        {renderInputOrSpan(renderAsSpans, tiers?.code || "N/A", classes)}

                      </Grid>
                      <Grid item  >
                        <div className={getLabelClass(renderAsSpans, classes)} style={{marginRight: "40px"}}>Nom et prénom</div>
                        {/*<input disabled className={classes.styleInput} type='text' name="nom" value={(tiers?.name + " " + tiers?.lastName)|| "N/A"}/>*/}
                        {renderInputOrSpan(renderAsSpans,  (tiers?.name + " " + tiers?.lastName) || "N/A", classes)}
                      </Grid>
                      <Grid item  >
                        <div className={getLabelClass(renderAsSpans, classes)} style={{marginRight: "40px"}}>Adresse</div>
                        {/*<input disabled className={classes.styleInput} type='text' name="adresse" value ={getAdresse(tiers?.partyAddresses)} />*/}
                        {renderInputOrSpan(renderAsSpans,  getAdresse(tiers?.partyAddresses), classes)}
                      </Grid>
                      <Grid item  >
                        <div className={getLabelClass(renderAsSpans, classes)}>Tél</div>
                        {/*<input disabled className={classes.styleInput} type="tel"  name="phone"  value ={getPhone(tiers?.partyCommunicationChannels)}/>*/}
                        {renderInputOrSpan(renderAsSpans, getPhone(tiers?.partyCommunicationChannels)|| "N/A", classes)}
                      </Grid>
                    <Grid item  >
                        <div className={getLabelClass(renderAsSpans, classes)} style={{marginRight: "40px"}}>Email</div>
                        {/*<input disabled className={classes.styleInput} type='email' name="email" value ={getEmail(tiers?.partyCommunicationChannels)}/>*/}
                {renderInputOrSpan(renderAsSpans,  getEmail(tiers?.partyCommunicationChannels)|| "N/A", classes)}
                    </Grid>
              </Grid>

              </AccordionPanel>
        </AccordionItem>
        ) : (
            <AccordionItem className={`${classes.customAccordionItem} ${renderAsSpans ? classes.expanded : ''}`} key={index}>
              <AccordionButton onClick={() => toggleExpansion(index, expandedItems, setExpandedItems)}
                               style={{ height: "47px", border: "none", background: "rgba(249, 249, 249, 1)", padding: "10px", borderRadius: "11px" }}>
                <AccordionIcon size="30px" style={{ backgroundColor: "rgba(240, 243, 199, 1)", width: "25px", height: "25px", borderRadius: "5px", color: "rgba(187, 200, 8, 1)" }} />
                <Box as="span"   textAlign='left' marginLeft='20px' style={{ color: "rgba(0, 34, 38, 1)", fontSize: '15px', fontWeight: 500, lineHeight: '21px', fontFamily: 'Poppins', }}>
                    {tiers?.organizationName}
                </Box>
                <div style={{
                                  marginLeft: '10px',   height: '26px', borderRadius: '51px', background: 'rgba(240, 243, 199, 1)', textAlign: 'center', padding: '5px 20px',
                                  fontFamily: 'Poppins', fontSize: '10.69px', fontWeight: 400, lineHeight: ' 16.03px', color: 'rgba(187, 200, 8, 1)',
                              }}>
                                  {tiers?.roleParty}
                              </div>
              </AccordionButton>
              <AccordionPanel style={{ width: "100%", background: 'rgba(255, 255, 255, 1)', padding: '30px' , borderRadius: "11px" }}>
              <Grid container style={{justifyContent: 'start' , marginBottom :'10px'}}  spacing={2} >
                      <Grid item  >
                        <div className={getLabelClass(renderAsSpans, classes)}  style={{marginRight: "40px"}} >Code</div>
                        {/*<input disabled className={classes.styleInput} type='text' name="code" value={tiers?.code || "N/A"} /> */}
                        {renderInputOrSpan(renderAsSpans,  tiers?.code || "N/A", classes)}
                      </Grid>
                      <Grid item  >
                        <div className={getLabelClass(renderAsSpans, classes)}  style={{marginRight: "40px"}} >Nom de l'organisation</div>
                        {/*<input disabled className={classes.styleInput} type='text' name="nom" value={tiers?.organizationName || "N/A"}/>*/}
                        {renderInputOrSpan(renderAsSpans,  tiers?.organizationName || "N/A", classes)}
                      </Grid>
                      <Grid item  >
                        <div className={getLabelClass(renderAsSpans, classes)}  style={{marginRight: "40px"}} >Adresse</div>
                        {/*<input disabled className={classes.styleInput} type='text' name="adresse" value ={getAdresse(tiers?.partyAddresses)} />*/}
                        {renderInputOrSpan(renderAsSpans, getAdresse(tiers?.partyAddresses) || "N/A", classes)}
                      </Grid>
                      <Grid item  >
                        <div className={getLabelClass(renderAsSpans, classes)}  style={{marginRight: "40px"}} >Tél</div>
                        {/*<input disabled className={classes.styleInput} type="tel"  name="phone"  value ={getPhone(tiers?.partyCommunicationChannels)}/>*/}
                        {renderInputOrSpan(renderAsSpans, getPhone(tiers?.partyCommunicationChannels) || "N/A", classes)}
                      </Grid>
                     <Grid item  >
                        <div className={getLabelClass(renderAsSpans, classes)}  style={{marginRight: "40px"}} >Email</div>
                        {/*<input disabled className={classes.styleInput} type='email' name="email" value ={getEmail(tiers?.partyCommunicationChannels)}/>*/}
                       {renderInputOrSpan(renderAsSpans, getEmail(tiers?.partyCommunicationChannels) || "N/A", classes)}
                      </Grid>
              </Grid>

              </AccordionPanel>
        </AccordionItem>
        )

       ))
      }</>
      }

       </Accordion>

    </div>
  )

}

export default TiersSection;